import React from "react";
import { sampleQR } from "../assets";

export default function DemoQR() {
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "100vh", backgroundColor: "#f5f5f5" }}>
      <h1 style={{ marginBottom: "24px", fontSize: "24px", fontWeight: "600", color: "#333" }}>
        Örnek QR Kodu
      </h1>
      <div style={{ backgroundColor: "#fff", padding: "32px", borderRadius: "12px", boxShadow: "0 4px 16px rgba(0,0,0,0.1)" }}>
        <img src={sampleQR} alt="Örnek QR Kodu" style={{ width: "300px", height: "300px", display: "block" }} />
      </div>
    </div>
  );
}
